import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import { show } from "redux-modal";
import { useDispatch } from "react-redux";
import BMXAsynchronousMulti from "../../../../../Components/Inputs/BMXAsynchronousMulti/BMXAsynchronousMulti";

import BMXAutocomplente from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";

const PartsFormStepOne = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [manufacturerSelect, setManufacturerSelect] = useState([]);
  // NEW COMPONENET
  const [printerModels, setPrinterModels] = useState([]);

  const { values, form } = props;

  const [loading, setLoading] = useState(false);

  const lastSearchTerm = useRef("");
  const activeController = useRef(null);

  const getData = async (searchTerm) => {
    if (!searchTerm || searchTerm === lastSearchTerm.current) {
      return printerModels; // zwracamy aktualny stan
    }

    // anuluj poprzednie zapytanie jeśli istnieje
    if (activeController.current) {
      activeController.current.abort();
    }

    const controller = new AbortController();
    activeController.current = controller;

    lastSearchTerm.current = searchTerm; // zapisujemy aktualne wyszukiwanie
    setPrinterModels([]); // wyczyszczenie poprzednich wyników
    setLoading(true);

    try {
      const data = await GlobalAuthFetch({
        path: `/printermodel/findByName/${searchTerm}`,
        signal: controller.signal, // dodajemy sygnał abortowania
      });

      const printerModelList =
        data?.payload?.data?.map((contact) => ({
          uuid: contact.uuid,
          value: contact.modelName,
          name: contact.modelName,
          ...contact,
        })) ?? [];

      setPrinterModels(printerModelList);
      return printerModelList;
    } catch (err) {
      if (err.name === "AbortError") {
        // zapytanie zostało anulowane, nie robimy nic
        return [];
      }
      setPrinterModels([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // LOADING DICTIONARIS
    const fetchData = async () => {
      const fetchManufacturer = GlobalAuthFetch({
        path: "/dictionary/manufacturer/fieldName",
      });

      const [payloadManufacturer] = await Promise.all([fetchManufacturer]);

      setManufacturerSelect(
        payloadManufacturer?.payload?.data?.dictionaryEntries
      );
    };
    fetchData();
  }, []);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:leasing.basicInformation")} />
      <Row>
        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:parts.manufacturerIndex")}*`}
            name="manufacturerIndex"
            data-cy="manufacturerIndex"
          />
        </Col>

        <Col xs={6}>
          <Field
            component={BMXAutocomplente}
            label={`${t("global:printerModel.manufacturer")}*`}
            name="manufacturer"
            data-cy="manufacturer"
            options={
              manufacturerSelect
                ?.sort((a, b) => a?.entryName?.localeCompare(b?.entryName))
                ?.map((el) => ({
                  uuid: el.uuid,
                  label: `${el.entryName || ""}`,
                })) || []
            }
            currentValues={values}
          />
        </Col>

        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:parts.name")}*`}
            name="name"
            data-cy="name"
          />
        </Col>

        <Col xs={4}>
          <Field
            component={BMXSelectField}
            values={[
              { name: t("global:yes"), value: "YES" },
              { name: t("global:no"), value: "NO" },
            ]}
            label={`${t("global:parts.substitute")}`}
            name="substitute"
            data-cy="substitute"
          />
        </Col>

        <Col xs={4}>
          <Field
            component={BMXTextField}
            label={`${t("global:parts.partsLifespan")}*`}
            name="partsLifespan"
            data-cy="partsLifespan"
          />
        </Col>

        <Col xs={4}>
          <Field
            name="price"
            label={`${t("global:parts.price")}`}
            component={BMXTextField}
            type="money"
            decimalScale={2}
            data-cy="price"
          />
        </Col>

        <Col xs={12}>
          <Field
            currentValues={values}
            component={BMXAsynchronousMulti}
            getOptionLabel={(option) =>
              option.modelName ||
              option.name ||
              option.label ||
              option.value ||
              ""
            }
            label={`${t("global:parts.printerModels")}*`}
            name="printerModels"
            loading={loading}
            options={printerModels}
            // clearIcon={<CleaningServicesOutlined fontSize="small" />}
            clearIcon={false}
            // disabled={update}
            getData={getData}
            data-cy="printerModels"
            disablePortal={true}
            onClose={() => {}}
          />
        </Col>
        <Col>
          <Field
            component={BMXTextField}
            label={`${t("global:parts.comments")}`}
            name="comments"
            data-cy="comments"
          />
        </Col>
      </Row>
    </div>
  );
};

export default PartsFormStepOne;
